import * as api from '../../services/season/api_season';
import * as apiCommon from '../../services/apiCommon';
import { browserHistory } from 'react-router';
import { delay, call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import * as SagaCommon from '../sagasCommon';
import * as DocType from '../../constants/constant_doc_types';
import * as SagasType from '../../constants/constant_saga_types';

export function* fetchListSeasonSaga(feathersApp) {
    yield takeLatest('FETCH_LIST_SEASON', callFetchListSeason, feathersApp);
}

function* callFetchListSeason(feathersApp, action) {
    const { silent, filters } = action;
    yield SagaCommon.showProgressListTable(silent);
    try {
        const dataParams = {
            filters,
            list_type: DocType.SEASON
        };
        const tableData = yield call(apiCommon.getDocs, feathersApp, dataParams);
        yield call(SagaCommon.doneListTable, { rows: tableData.data, total_rows: tableData.total });
    } catch (error) {
        yield SagaCommon.showErrorListTable(error);
    }
}

export function* saveSeasonSaga(feathersApp) {
    yield takeEvery("SAVE_SEASON", callSaveSeason, feathersApp);
}
function* callSaveSeason(feathersApp, action) {
    const { tenant, user } = yield select();
    try {
        yield put({ type: 'SAVE_RECORD_INPROGRESS' });

        const params = { tenant, user, data: action.data };
        const result = yield call(api.saveSeason, feathersApp, params);

        yield SagaCommon.doneSaveRecord(result, 'Season was saved');
        yield put({ type: SagasType.SIMPLE_FORM_SET_DATA, data: result });
        yield callFetchListSeason(feathersApp, { silent: true });

    } catch (e) {
        yield SagaCommon.showErrorSaveRecord(e);
    }
}

export function* deleteSeasonFromListSaga(feathersApp) {
    yield takeEvery('DELETE_SEASON_FROM_LIST', callDeleteSeasonFromList, feathersApp);
}

function* callDeleteSeasonFromList(feathersApp, action) {
    yield deleteSeason(feathersApp, action);
    yield delay(2000);
    yield callFetchListSeason(feathersApp, { silent: true });
}

function* deleteSeason(feathersApp, action) {
    yield put({ type: 'DELETE_RECORD_INPROGRESS' });
    try {
        const { id } = action;
        let result = null;
        if (id) {
            const state = yield select();
            const { tenant, user } = state;
            const params = { tenant, user, id };
            result = yield call(api.deleteSeason, feathersApp, params);
            yield put({ type: "DELETE_RECORD_DONE", payload: { id, docType: DocType.SEASON } });
            yield callFetchListSeason(feathersApp, { silent: true });
        }
        return result;
    } catch (error) {
        yield put({ type: 'DELETE_RECORD_ERROR', error })
    }
}

export function* deleteSeasonSaga(feathersApp) {
    yield takeEvery('DELETE_SEASON', callDeleteSeason, feathersApp);
}

function* callDeleteSeason(feathersApp, action) {
    const result = yield deleteSeason(feathersApp, action);
    yield delay(2000);
    if (result) {
        browserHistory.push('/admin/season');
    }
}

export function* fetchSeasonForEditSaga(feathersApp) {
    yield takeEvery('FETCH_SEASON_BY_ID', callFetchSeasonForEdit, feathersApp);
}

function* callFetchSeasonForEdit(feathersApp, action) {
    const { tenant, user } = yield select();
    const { id } = action;
    const docType = DocType.SEASON;
    try {
        if (id) {
            yield put({ type: "FETCH_DATA_BY_ID_INPROGRESS", payload: { docType, id } });
            const fetchParams = { tenant, user, id };
            const doc = yield call(api.fetchSeasonById, feathersApp, fetchParams);
            yield SagaCommon.doneDataById(doc);
			yield put({
				type: SagasType.SIMPLE_FORM_SET_DATA,
				data: doc
			});
        }
    } catch (error) {
        yield put({ type: "FETCH_DATA_BY_ID_ERROR", error: error });
    }
}
